import {
    UPDATE_PRODUCT,
    UPDATE_PRODUCT_FAILED,
    RESET_FORMS
} from '../actions/types'

const initialState = {}

const updateProductReducer = (state = initialState, action) => {
    switch(action.type){
        case UPDATE_PRODUCT:
            return {
                details: action.payload,
                success: 'Product updated successfully',
            }
        case UPDATE_PRODUCT_FAILED:
            return {
                ...state,
                errors: action.payload,
                success: null
            }
        case RESET_FORMS:
            return initialState
        default:
            return state
    }
}

export default updateProductReducer